export default {"src":"/_next/static/image/src/onboarding/AccountFeatures/pup-info.2fbeb0f7a661e64304840aee4ef017c7.svg","height":70,"width":69};